export default __webpack_public_path__ + "static/media/CNo.68-8.d3b22a58.jpg";